import {dateConvert} from "../../plugins/utils";
import moment         from 'moment';

export default {
    package_addons    : {
        '__remote': true,
        query     : (state) => ({
            category: state.model.reservation.is_seasonal ? 'seasonal':'daily',
            is_from_kiosk: state.model.reservation.is_from_kiosk ?? 0,
            date_pickup: !state.model.reservation.is_seasonal?dateConvert(state.model.reservation.date_pickup):state.model.reservation.date_pickup,
            date_return: !state.model.reservation.is_seasonal ? dateConvert(state.model.reservation.date_return) : state.model.reservation.date_return,
        }),
    },
    skier_types       : {'__remote': true},
    policy_and_terms  : {'__remote': true},
    packages          : {
        '__remote': true,
        query     : (state) => ({
            date_pickup: !state.model.reservation.is_seasonal && state.model.reservation.group_link_id==0 ? dateConvert(state.model.reservation.date_pickup):state.model.reservation.date_pickup,
            date_return: !state.model.reservation.is_seasonal && state.model.reservation.group_link_id==0 ? dateConvert(state.model.reservation.date_return) : state.model.reservation.date_return,
            is_delivery: state.model.reservation.is_delivery ?? 0,
            category: state.model.reservation.is_seasonal ? 'seasonal':'daily',
            is_from_kiosk: state.model.reservation.is_from_kiosk ?? 0,
            is_day_before: state.model.reservation.pickup_day ?? 'day_of',
            is_prepay: state.model.reservation.is_prepay ?? 0,
        }),
        process   : data => data
    },
    group_packages          : {
        '__remote': true,
        process   : data => data
    },
    prepay_packages          : {
        '__remote': true,
        query     : (state) => ({
            date_pickup: state.model.reservation.date_pickup,
            date_return: state.model.reservation.date_return,
            is_delivery: state.model.reservation.is_delivery ?? 0,
            category: 'seasonal',
            is_from_kiosk: state.model.reservation.is_from_kiosk ?? 0,
            is_prepay: state.model.reservation.is_prepay ?? 0,
        }),
        process   : data => data
    },
    package_categories: {value: []},
}
